 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"createApp":"createApp","DoubleRestocking":"DoubleRestocking","Geographic":"Geographic","Nomenclature":"Nomenclature"}[chunkId]||chunkId) + "." + {"createApp":"fc455106","DoubleRestocking":"e4191e9e","Geographic":"ac505784","Nomenclature":"96deabf2","chunk-2d0a4b80":"9af951a3","chunk-2d0aab65":"fb77a476","chunk-2d0afda3":"2b36543e","chunk-2d0b1d8a":"cef6d3c6","chunk-2d0b26e6":"4e62e85e","chunk-2d0b368c":"2b6c5df6","chunk-2d0b3a5c":"7208bd93","chunk-2d0b596d":"beef5f39","chunk-2d0b64f9":"80e1105d","chunk-2d0be6d5":"5347c35e","chunk-2d0c0a25":"382e8331","chunk-2d0c0ec3":"6c8627c5","chunk-2d0c22ab":"005b1775","chunk-2d0c432f":"e2922951","chunk-2d0c47f8":"e7ea6409","chunk-2d0c9556":"b8ccc016","chunk-2d0cc032":"130e283c","chunk-2d0cfe39":"48e50e58","chunk-2d0d004a":"f24a09c9","chunk-2d0d017d":"d7867f1f","chunk-2d0d2f41":"e32e8a7f","chunk-2d0d624f":"8bda2592","chunk-2d0d6770":"4747c515","chunk-2d0d7659":"a57e5eca","chunk-2d0dd08c":"c2f608bb","chunk-2d0dd7a5":"8db9a4e2","chunk-2d0dd821":"cfdde50e","chunk-2d0de2e9":"16d415df","chunk-2d0de3df":"856e1f00","chunk-2d0e4cd0":"c38d91c1","chunk-2d0e97b0":"388ba6f3","chunk-2d0efc70":"e7c00515","chunk-2d207410":"cabd3a47","chunk-2d20809f":"ceb85830","chunk-2d20881b":"7a6e2642","chunk-2d208a7b":"1e1ebf1c","chunk-2d209ade":"136646c3","chunk-2d20edd6":"09b232dc","chunk-2d210fdd":"a08c12ba","chunk-2d213e5b":"eb9ad517","chunk-2d215c2a":"0964be17","chunk-2d2163c7":"a5069627","chunk-2d217389":"74ebaa0b","chunk-2d221e05":"86a946f4","chunk-2d221fd3":"934b604d","chunk-2d2226cd":"f71c3157","chunk-2d225468":"d7923f08","chunk-2d2268cb":"efd842a5","chunk-2d22c885":"1f765ff9","chunk-2d22c8e3":"75ec2bd3","chunk-2d22d387":"7ca45efb","chunk-2d22d599":"1f8ebc24","chunk-2d22d95e":"29b019a0","chunk-2d2378b5":"624b454e","chunk-2d237cc4":"1acedc79"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"createApp":1,"DoubleRestocking":1,"Geographic":1,"Nomenclature":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"createApp":"createApp","DoubleRestocking":"DoubleRestocking","Geographic":"Geographic","Nomenclature":"Nomenclature"}[chunkId]||chunkId) + "." + {"createApp":"acb60809","DoubleRestocking":"c836eda8","Geographic":"2ce20ac7","Nomenclature":"e8c8f367","chunk-2d0a4b80":"31d6cfe0","chunk-2d0aab65":"31d6cfe0","chunk-2d0afda3":"31d6cfe0","chunk-2d0b1d8a":"31d6cfe0","chunk-2d0b26e6":"31d6cfe0","chunk-2d0b368c":"31d6cfe0","chunk-2d0b3a5c":"31d6cfe0","chunk-2d0b596d":"31d6cfe0","chunk-2d0b64f9":"31d6cfe0","chunk-2d0be6d5":"31d6cfe0","chunk-2d0c0a25":"31d6cfe0","chunk-2d0c0ec3":"31d6cfe0","chunk-2d0c22ab":"31d6cfe0","chunk-2d0c432f":"31d6cfe0","chunk-2d0c47f8":"31d6cfe0","chunk-2d0c9556":"31d6cfe0","chunk-2d0cc032":"31d6cfe0","chunk-2d0cfe39":"31d6cfe0","chunk-2d0d004a":"31d6cfe0","chunk-2d0d017d":"31d6cfe0","chunk-2d0d2f41":"31d6cfe0","chunk-2d0d624f":"31d6cfe0","chunk-2d0d6770":"31d6cfe0","chunk-2d0d7659":"31d6cfe0","chunk-2d0dd08c":"31d6cfe0","chunk-2d0dd7a5":"31d6cfe0","chunk-2d0dd821":"31d6cfe0","chunk-2d0de2e9":"31d6cfe0","chunk-2d0de3df":"31d6cfe0","chunk-2d0e4cd0":"31d6cfe0","chunk-2d0e97b0":"31d6cfe0","chunk-2d0efc70":"31d6cfe0","chunk-2d207410":"31d6cfe0","chunk-2d20809f":"31d6cfe0","chunk-2d20881b":"31d6cfe0","chunk-2d208a7b":"31d6cfe0","chunk-2d209ade":"31d6cfe0","chunk-2d20edd6":"31d6cfe0","chunk-2d210fdd":"31d6cfe0","chunk-2d213e5b":"31d6cfe0","chunk-2d215c2a":"31d6cfe0","chunk-2d2163c7":"31d6cfe0","chunk-2d217389":"31d6cfe0","chunk-2d221e05":"31d6cfe0","chunk-2d221fd3":"31d6cfe0","chunk-2d2226cd":"31d6cfe0","chunk-2d225468":"31d6cfe0","chunk-2d2268cb":"31d6cfe0","chunk-2d22c885":"31d6cfe0","chunk-2d22c8e3":"31d6cfe0","chunk-2d22d387":"31d6cfe0","chunk-2d22d599":"31d6cfe0","chunk-2d22d95e":"31d6cfe0","chunk-2d2378b5":"31d6cfe0","chunk-2d237cc4":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
